<vl-data-table class="aeg-datatable" :mod-zebra="!emptyState || loading"
               :mod-hover="!emptyState || loading">
    <thead class="aeg-datatable-header aeg-invoices-header">
    <tr v-if="!hideHeaderPagination">
        <td colspan="8" class="aeg-datatable-pager">
            <aeg-pagination :page-size="pagedInvoices.pagingInfo.pageSize"
                            :current-page="pagedInvoices.pagingInfo.page"
                            :results="pagedInvoices.pagingInfo.totalPages"
                            :total="pagedInvoices.pagingInfo.totalItems"
                            @page-change="changePage"/>
        </td>
    </tr>
    <tr>
        <th>Datum
            <vl-icon icon="arrow-down"/>
        </th>
        <th>Doc nummer</th>
        <th>Service</th>
        <th>Crediteur</th>
        <th>Type</th>
        <th class="aeg-invoices-header__amount">Bedrag</th>
        <th class="aeg-invoices-header__payment vl-u-align-center">Betaald</th>
        <th class="aeg-invoices-header__download vl-u-align-center">PDF</th>
        <th class="aeg-invoices-header__download vl-u-align-center">CSV</th>
    </tr>
    </thead>
    <tbody>
    <tr v-if="loading">
        <td colspan="9">
            <div class="aeg-datatable__loading">
                <vl-loader message="De gegevens worden geladen. Even geduld, a.u.b."/>
            </div>
        </td>
    </tr>
    <tr v-else-if="emptyState">
        <td colspan="9">
            <div class="aeg-datatable__empty">
                U heeft nog geen inkoopfacturen.
            </div>
        </td>
    </tr>
    <tr v-else v-for="invoice in pagedInvoices.items" :key="invoice.documentReference">
        <td>{{ formatDate(invoice.submitTimestamp) }}</td>
        <td>{{ invoice.invoiceNumber }}</td>
        <td class="uppercase">{{ invoice.service }}</td>
        <td>{{ invoice.actorName }}</td>
        <td>{{ getDocumentTypeLabel(invoice.documentType) }}</td>
        <td>
            <div class="aeg-invoices-details">
                            <span class="aeg-invoices-details-type">
                                <vl-icon mod-icon-only :icon="getInvoiceTypeIcon(invoice.documentType, invoice.paymentMethod)" :class="{'aeg-details-table-details__topup': isTopUpType(invoice.documentType)}" />
                            </span>
                <vl-icon icon="euro" :class="{'aeg-invoices__payment-icon': isTopUpType(invoice.documentType)}"/>
                <span :class="{'aeg-invoices-details__topup aeg-invoices__payment': isTopUpType(invoice.documentType) }"> 
                                {{
                        isTopUpType(invoice.documentType) ? `+ ${formatCurrency(invoice.totalPrice)}` : formatCurrency(invoice.totalPrice)
                    }}
                            </span>
            </div>
        </td>
        <td class="vl-u-align-center">
            <vl-icon v-if="invoice.paid" mod-icon-only
                     icon="check" hidden-text="Betaald" class="vl-u-align-center aeg-invoices__payment-icon">
            </vl-icon>
        </td>
        <td class="vl-u-align-center">
            <vl-link v-if="invoice.directPdfUrl" :href="invoice.directPdfUrl" mod-icon-only
                     icon="file-office-pdf"
                     hidden-text="Download als PDF" class="vl-u-align-center">
            </vl-link>
        </td>
        <td class="vl-u-align-center">
            <vl-link v-if="!isTopUpType(invoice.documentType) || invoice.directCsvUrl" :href="invoice.directCsvUrl"
                     mod-icon-only
                     icon="file-office-xls" hidden-text="Download als CSV" class="vl-u-align-center">
            </vl-link>
        </td>
    </tr>
    </tbody>
    <tfoot v-if="!emptyState">
    <tr>
        <td colspan="2" class="aeg-invoices-download">
            <vl-link :href="downloadFileUri" icon="download-harddisk"
                     mod-icon-before v-if="showDownloadLink">Download
            </vl-link>
        </td>
        <td colspan="6" class="aeg-datatable-pager">
            <aeg-pagination :page-size="pagedInvoices.pagingInfo.pageSize"
                            :current-page="pagedInvoices.pagingInfo.page"
                            :results="pagedInvoices.pagingInfo.totalPages"
                            :total="pagedInvoices.pagingInfo.totalItems"
                            @page-change="changePage"/>
        </td>
    </tr>
    </tfoot>
</vl-data-table>

